<template>
  <div class="container-fluid">
    <card-title title="BENEFICIOS FINANCIEROS" icon="chart-box-outline">
      <template #content>
        <v-card class="mx-auto elevation-5" outlined>
          <div>
            <v-progress-linear
              v-if="loading"
              :indeterminate="loading"
              color="cyan"
            />
            <div v-if="!loading" class="elevation-5">
              <div class="card-body text-lg-center">
                <v-simple-table dense>
                  <template #default>
                    <thead>
                      <tr class="text-black custom-body-hs font-size-x">
                        <td
                          v-for="(item, index) in bonusHeaders"
                          :key="index"
                          class="box-shadow"
                          :style="index < 1 ? 'width:42%' : ''"
                        >
                          {{ item.text }}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(item, index) in bonus">
                        <tr
                          v-if="isBonusVisible(item.CODIGO)"
                          :key="index"
                          class="no-border custom-body-hs font-size-x"
                        >
                          <td class="text-center pl-1 py-0 pr-0">
                            <span>
                              <router-link
                                v-if="isCashActive(item.CODIGO)"
                                :to="{
                                  name: 'AccountStatus',
                                  params: { disc: 'PSPO' },
                                }"
                                class="text-decoration-none text-black text-decoration-underline"
                              >
                                {{ formatTitle(item.TITULO) }}
                              </router-link>
                              <v-tooltip
                                v-else-if="isPrePayment(item.CODIGO)"
                                bottom
                              >
                                <template #activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">{{
                                    formatTitle(item.TITULO)
                                  }}</span>
                                </template>
                                <span
                                  >Descuento aplicado al pagar facturas</span
                                >
                              </v-tooltip>
                              <span v-else>
                                {{ formatTitle(item.TITULO) }}
                              </span>
                            </span>
                            <template v-if="isPoPBonus(item.CODIGO)">
                              <v-progress-circular
                                v-if="loadingCashRegister"
                                indeterminate
                                color="primary"
                              />
                              <v-tooltip v-else top>
                                <template #activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    :color="cashRegisterColor[index]"
                                    v-on="on"
                                  >
                                    mdi-cash-register
                                  </v-icon>
                                </template>
                                <span style="white-space: pre-wrap">{{
                                  showMessage(item.CODIGO, index)
                                }}</span>
                              </v-tooltip>
                            </template>
                          </td>
                          <td v-for="period in [4, 3, 2, 1]" :key="period">
                            <template v-if="isPrePayment(item.CODIGO)">
                              ${{ number_format(item[`PERIODO${period}`]) }}
                            </template>
                            <register-cash
                              v-else
                              :value="Number(item[`PERIODO${period}`])"
                              :cash-register-color="
                                cashRegisterColorItem(
                                  item[`PERIODO${period}`],
                                  period
                                )
                              "
                              :show-value="true"
                              :show-cash-register="
                                isPoPBonus(item.CODIGO) && period > 1
                              "
                              :show-pending-text="false"
                              :show-action-link="false"
                            />
                          </td>
                        </tr>
                      </template>
                      <tr class="no-border custom-body-hs font-size-x">
                        <td class="text-center pl-1 py-0 pr-0">
                          <span>Detalle POP</span>
                        </td>
                        <td colspan="2"></td>
                        <td
                          colspan="2"
                          class="d-flex justify-content-center align-center gap-2 text-decoration-underline"
                        >
                          <a @click="showPopDetails()">Detalle</a>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </div>
        </v-card>
      </template>
    </card-title>
    <pop-bonus-detail
      v-model="popDetails.modal"
      :data="popDetails.data"
      :loading="popDetails.loading"
      @refresh="showPopDetails"
    />
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import axios from '@/plugins/axios';
  import { mapGetters } from 'vuex';
  import helpers from '@/mixins/helpers.js';
  import CardTitle from '@/components/CardTitle.vue';
  import RegisterCash from '@/components/RegisterCash.vue';
  import PopBonusDetail from './PopBonusDetail.vue';
  import moment from 'moment';
  export default {
    name: 'QuarterlyBonus',
    components: {
      CardTitle,
      RegisterCash,
      PopBonusDetail,
    },
    mixins: [helpers],
    props: {
      generalInfoCustomer: {
        default: {},
      },
    },
    data() {
      return {
        ielBonus: {},
        isPR: false,
        loadingIelBonus: false,
        bonus: [],
        paymentDetails: [],
        bonusHeaders: [],
        loading: true,
        cashRegisterColor: [],
        validDateForPOPBonus: [],
        popCode: '262',
        popDetails: {
          loading: false,
          modal: false,
          data: {
            items: [],
            cashRegister: [],
            title: '',
          },
        },
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
        cashRegister: 'bonusCustomer/cashRegister',
        loadingCashRegister: 'bonusCustomer/loadingCashRegister',
      }),
    },
    watch: {
      generalInfoCustomer() {
        let self = this;
        self.getBonus();
        if (this.generalInfoCustomer.VTWEG != 'PR') {
          self.getIelBonus();
        } else {
          this.isPR = true;
        }
      },
    },
    mounted() {
      this.validDateForPOPBonus = moment().subtract(1, 'year').month(8);
    },
    methods: {
      async showPopDetails() {
        this.popDetails.loading = true;
        this.popDetails.data = {};
        this.popDetails.modal = true;
        const cashRegister = this.findCashRegisterCode(this.popCode);
        try {
          const params = {
            user: this.generalInfoCustomer.KUNNR,
            channel: this.generalInfoCustomer.VTWEG,
          };

          const res = await axios.get('/bonus/customer/pop-details', {
            params,
          });
          this.popDetails.data = {
            items: res.data,
            cashRegister: cashRegister,
            title: this.bonusHeaders[3].text,
          };
        } catch (error) {
          this.$swal(
            'Ops, Hubo problemas al cargar la información. Por favor intente más tarde'
          );
          this.popDetails.modal = false;
        }

        this.popDetails.loading = false;
      },
      isBonusVisible(itemCode) {
        return this.isPoPBonus(itemCode) || this.isPrePayment(itemCode);
      },
      cashRegisterColorItem(value, quarter) {
        if (quarter === 2 && this.isPR) {
          return value > 0 ? 'green' : 'gray';
        }
        if (!this.isPR) {
          return value > 0 ? 'green' : 'gray';
        }
        return 'gray';
      },
      isPrePayment(paymentCode) {
        if (this.isPR && paymentCode == 201) {
          return true;
        }
        return paymentCode == 273;
      },
      isPoPBonus(code) {
        return code == 262;
      },
      formatTitle(title) {
        return title.replace(/ /g, '\u00a0'); // Unicode for &nbsp;
      },
      findCashRegisterCode(code) {
        return this.cashRegister.find((item) => item.CODIGO === code) || null;
      },
      isCashActive(code) {
        if (this.isPR && this.isPrePayment(code)) {
          return false;
        }
        const item = this.findCashRegisterCode(code);
        return item?.DISPO > 0;
      },
      showMessage(code, index) {
        const item = this.findCashRegisterCode(code);
        let amount = 0;
        let available = 0;
        if (item) {
          if (item.DISPO > 0) this.cashRegisterColor[index] = 'green';
          amount = item.MONTO;
          available = item.DISPO;
        }
        return `Total de bono ganado (importe s/IVA) :$ ${this.number_format(
          amount
        )}
        Total Acumulado disponible (importe s/IVA) :$ ${this.number_format(
          available
        )}`;
      },
      getIelBonus() {
        this.loadingIelBonus = true;
        const params = {
          customer_id: this.generalInfoCustomer.KUNNR,
        };
        axios
          .post('/cover/IELBonus', params)
          .then(
            (response) => {
              this.ielBonus = response.data;
              this.loadingIelBonus = false;
            },
            {
              noCancelRequest: true,
              cachable: true,
            }
          )
          .catch(() => {
            this.loadingIelBonus = false;
          });
      },
      getMonthNamesByPeriod(period) {
        var currentTrim = this.trims[period - 1][period].split('/');
        var months = currentTrim[0].split('-');
        var year = '20' + currentTrim[1];
        for (let i = 0; i < months.length; i++) {
          months[i] = months[i] + '/' + year;
        }
        return months;
      },
      getBonus() {
        this.loading = true;
        axios
          .post(
            'indicatorsBonos',
            {
              client_code: this.generalInfoCustomer.KUNNR,
              channel: this.generalInfoCustomer.VTWEG,
            },
            {
              noCancelRequest: true,
              cachable: true,
            }
          )
          .then((response) => {
            const headerBonus = response.data.header;
            this.bonus = response.data.data;
            this.bonusHeaders = [
              {
                text: 'Concepto',
                align: 'start',
                value: 'TITULO',
                class: 'border-bottom: none;',
                sortable: false,
              },
              {
                text: headerBonus[0].PERIODO4,
                sortable: false,
                value: 'PERIODO1',
              },
              {
                text: headerBonus[0].PERIODO3,
                sortable: false,
                value: 'PERIODO2',
              },
              {
                text: headerBonus[0].PERIODO2,
                sortable: false,
                value: 'PERIODO3',
              },
              {
                text: headerBonus[0].PERIODO1,
                sortable: false,
                value: 'PERIODO4',
              },
            ];
            this.trims = [
              { 1: headerBonus[0].PERIODO1 },
              { 2: headerBonus[0].PERIODO2 },
              { 3: headerBonus[0].PERIODO3 },
              { 4: headerBonus[0].PERIODO4 },
            ];
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style src="@/assets/css/customerHome.css" scoped></style>
